/* eslint-disable no-useless-escape */
export function stabilizePhoneInput(value: string): string {
  if (!value) return "";

  let v = value;
  v = v.replace(/[^\d\(\)\-\s\+]/g, "");

  if (v.startsWith("+")) {
    v = "+" + v.slice(1).replace(/\+/g, "");
  } else {
    v = "+" + v.replace(/\+/g, "");
  }

  v = v.replace(/([()\-\s]){2,}/g, "$1");

  return v;
}

export function stabilizeLocalPhoneInput(value: string): string {
  if (!value) return "";

  let v = value.replace(/[^\d\(\)\-\s]/g, "");
  v = v.replace(/([()\-\s]){2,}/g, "$1");

  return v;
}
